import { render, staticRenderFns } from "./ResetarSenha.vue?vue&type=template&id=dc7e6ee4&"
import script from "./ResetarSenha.vue?vue&type=script&lang=js&"
export * from "./ResetarSenha.vue?vue&type=script&lang=js&"
import style0 from "./ResetarSenha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports